module.exports = __webpack_public_path__ + "static/img/tree-owl.bf7e190.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/hellohr/tree-owl.svg
// module id = BM/R
// module chunks = 0